import { render, staticRenderFns } from "./SpecialOrder.vue?vue&type=template&id=4c9f3d96&scoped=true&"
import script from "./SpecialOrder.vue?vue&type=script&lang=js&"
export * from "./SpecialOrder.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOrder.vue?vue&type=style&index=0&id=4c9f3d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f3d96",
  null
  
)

export default component.exports